import { Helmet } from 'react-helmet';
import {
  Box,
  Container,
  Grid,
  Button,
  Card,
  CardContent,
  TextField
} from '@mui/material';
import React, { Component } from 'react';
import SearchRecords from 'src/components/pages/vaccination/dashboard/SearchRecords';
import RequestChart from 'src/components/pages/vaccination/dashboard/RequestChart';
import StatusCount from 'src/components/pages/vaccination/dashboard/StatusCount';
import masterStatus from 'src/models/status';
import Traffic from 'src/components/pages/vaccination/dashboard/TrafficByType';
import { _axios } from 'src/plugins/axios';
import moment from 'moment';
import * as _ from 'lodash';
import Report from '@mui/icons-material/Report';
import Beenhere from '@mui/icons-material/Beenhere';
import Cancel from '@mui/icons-material/Cancel';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import OfflinePin from '@mui/icons-material/OfflinePin';
import commonService from 'src/service/common';
import goodalipi from 'src/plugins/goodalipi';
import ClevertapReact from 'clevertap-react';

const masterDataCountItems = JSON.parse(JSON.stringify(masterStatus));

const iconMapping = {
  AttendedCount: <Beenhere fontSize="large" style={{ color: 'white' }} />,
  CanceledCount: <Cancel fontSize="large" style={{ color: 'white' }} />,
  ConfirmedCount: <OfflinePin fontSize="large" style={{ color: 'white' }} />,
  NewAppointmentCount: (
    <PermContactCalendarIcon fontSize="large" style={{ color: 'white' }} />
  ),
  NotAttendedCount: <Report fontSize="large" style={{ color: 'white' }} />
};

const daysToPreFetch = 30;

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: {
        dateRange: [],
        campLocation: [],
        providerName: [],
        campType: [],
        benf: [],
        payment: '',
        entityRequested: ''
      },
      filterOptions: {
        campLocationList: [],
        providerNameList: [],
        campTypeList: [],
        paymetnList: [],
        benfList: [],
        entityRequested: goodalipi.get('globalHRgroup')
      },
      officeCampusRequests: [],
      hospitalRequests: [],
      masterDataCountItems: [],
      salesChartOptions: {
        view: null,
        data: null
      },
      groupChartOptions: {
        gender: null,
        relation: null
      },
      error: {
        piechart: false
      }
    };
  }
  //refresh data
  applyFilters() {
    const payload = {};
    if (this.state.filter.campLocation.length)
      payload.campLocation = this.state.filter.campLocation;
    if (this.state.filter.campType.length)
      payload.campType = this.state.filter.campType;
    if (this.state.filter.providerName.length)
      payload.providerName = this.state.filter.providerName;
    if (this.state.filter.payment) payload.payment = this.state.filter.payment;
    if (this.state.filter.benf.length) payload.benf = this.state.filter.benf;
    if (this.state.filter.entityRequested) {
      payload.globalHR = true;
      payload.entityRequested = this.state.filter.entityRequested;
    }
    if (this.state.filter.dateRange.length == 2) {
      let startDate = new Date(this.state.filter.dateRange[0]);
      let endDate = new Date(this.state.filter.dateRange[1]);
      payload['apptDateBegin'] =
        startDate.getFullYear() +
        '-' +
        ('0' + (startDate.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + startDate.getDate()).slice(-2);
      payload['apptDateEnd'] =
        endDate.getFullYear() +
        '-' +
        ('0' + (endDate.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + endDate.getDate()).slice(-2);
    }
    this.refreshChartOption(daysToPreFetch, { ...payload });
    this.refreshTypeCount({ ...payload });
    this.refreshData({ ...payload });
  }
  //total status count call
  refreshData(payLoad = {}) {
    // if(sessionStorage.getItem('statuscount') && _.keys(payLoad).length==0) {
    //   this.setState({
    //     masterDataCountItems: JSON.parse(sessionStorage.getItem('statuscount')).masterDataCountItems
    //   })
    //   return
    // }
    payLoad.statType = 'day';
    this.setState(
      {
        masterDataCountItems:
          goodalipi.get('isMinor') == 'isBooleantrue'
            ? _.filter(
              JSON.parse(JSON.stringify(masterDataCountItems)),
              function (o) {
                return (
                  o.statusName != 'Cancelled' && o.statusName != 'NotAttended'
                );
              }
            )
            : JSON.parse(JSON.stringify(masterDataCountItems))
      },
      () => {
        _axios
          .post('masterData/getAllTypeCount?contractType=14364', payLoad, {
            ignoreLoading: true
          })
          .then((response) => {
            if (response.data) {
              const data = [...this.state.masterDataCountItems];
              _.keysIn(response.data).forEach((key) => {
                if (key != 'isSuccess') {
                  data.forEach((status, idx) => {
                    status.totalCount += response.data[key][status.statusName]
                      ? response.data[key][status.statusName]
                      : 0;
                  });
                }
              });
              data.forEach((data) => {
                data.totalCount = data.totalCount ? data.totalCount : 'NA';
              });
              delete payLoad.statType;
              if (_.keys(payLoad).length == 0 && response.data.isSuccess) {
                sessionStorage.setItem(
                  'statuscount',
                  JSON.stringify({
                    masterDataCountItems: data
                  })
                );
              }
              this.setState({
                masterDataCountItems: data
              });
            }
          })
          .catch((error) => {
            // alert(error);
          });
      }
    );
  }

  refreshChartView(days) {
    const salesOptions = this.state.salesChartOptions;
    this.setState({
      salesChartOptions: {
        data: salesOptions.data,
        view: {
          datasets: salesOptions.data.datasets.map((each) => {
            console.log('zzzz: ', each, days);
            let option = Object.assign({}, each);
            option.data = each.data.slice(-days);
            return option;
          }),
          labels: salesOptions.data.labels.slice(-days)
        }
      }
    });
  }
  //bar graph call
  refreshChartOption(till, payload = {}) {
    // if(sessionStorage.getItem('salesChartOptions') && _.keys(payload).length==0) {
    //   this.setState({
    //     salesChartOptions: JSON.parse(sessionStorage.getItem('salesChartOptions'))
    //   })
    //   return
    // }
    let lastSelectedDays = {};
    if (
      moment(payload.apptDateEnd).diff(moment(payload.apptDateBegin), 'days') <
      14 &&
      payload.apptDateEnd
    ) {
      till = moment(payload.apptDateEnd).diff(
        moment(payload.apptDateBegin),
        'days'
      );
    }
    _.forEach(
      [...Array(till).keys()].reverse().map((value) => value + 1),
      (days) => {
        lastSelectedDays[
          moment(payload.apptDateEnd).subtract(days, 'd').format('YYYY-MM-DD')
        ] = {};
      }
    );
    payload.statType = 'day';
    if (!payload.apptDateEnd) {
      payload.apptDateBegin = moment().subtract(till, 'd').format('YYYY-MM-DD');
      payload.apptDateEnd = moment().subtract(1, 'd').format('YYYY-MM-DD');
    }
    // console.log(moment(payload.apptDateEnd), moment(payload.apptDateBegin))
    // console.log(moment(payload.apptDateEnd).diff(moment(payload.apptDateBegin), 'days'))
    // console.log(payload)
    // console.log(lastSelectedDays)
    // return
    this.setState({
      salesChartOptions: {
        view: null,
        data: null
      }
    });
    _axios
      .post('masterData/getAllTypeCount?contractType=14364', payload, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken()
        }
      })
      .then((response) => {
        if (response.data) {
          _.keys(response.data).forEach((each) => {
            if (each != 'isSuccess' && each in lastSelectedDays) {
              lastSelectedDays[each] = response.data[each];
            }
            // each.appointmentDate = moment(each.appointmentDate).startOf('day').format('DD-MMM');
          });
          const data = {
            labels: Object.keys(lastSelectedDays).map((each) =>
              moment(each).format('DD-MMM')
            ),
            datasets: []
          };
          data.datasets = (
            goodalipi.get('isMinor') == 'isBooleantrue'
              ? _.filter(masterDataCountItems, function (o) {
                return (
                  o.statusName != 'Cancelled' && o.statusName != 'NotAttended'
                );
              })
              : masterDataCountItems
          ).map((value) => {
            return {
              backgroundColor: value.bgColor,
              data: Object.values(lastSelectedDays).map((each) =>
                each[value.statusName] ? each[value.statusName] : 0
              ),
              label: value.status,
              barPercentage: 0.5,
              barThickness: 6,
              maxBarThickness: 4,
              minBarLength: 2
            };
          });
          this.setState({
            salesChartOptions: {
              view: data,
              data
            }
          });
          delete payload.statType;
          delete payload.apptDateBegin;
          delete payload.apptDateEnd;
          if (_.keys(payload).length == 0) {
            // sessionStorage.setItem('salesChartOptions', JSON.stringify({
            //   view: data,
            //   data
            // }))
          }
        }
      })
      .catch((error) => {
        //alert(error);
      });
  }
  //donought charts call
  refreshTypeCount(payLoad = {}) {
    // if(sessionStorage.getItem('groupChartOptions') && _.keys(payLoad).length==0) {
    //   this.setState({
    //     groupChartOptions: JSON.parse(sessionStorage.getItem('groupChartOptions'))
    //   })
    //   return
    // }
    // payLoad = {
    //   "apptDateBegin": null,
    //   "apptDateEnd": null,
    // }
    this.setState({
      groupChartOptions: {
        gender: null,
        relation: null
      },
      error: {
        piechart: false
      }
    });
    this.state.error.piechart = true;
    _axios
      .post('masterData/count', payLoad, {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken(),
          'Content-Type': 'application/json'
        }
      })
      .then((response) => {
        if (response.data) {
          const gender = {
            Male: 0,
            Female: 0
          };
          let totalCount = 0;
          const relation = response.data.relation.filter(
            (each) => each.count > 0 && each.relation
          );
          if (response.data.gender) {
            totalCount = response.data.gender.reduce(
              (a, item) => a + item.count,
              totalCount
            );
            response.data.gender.forEach((each) => {
              if (['f', 'female'].indexOf(each.gender.toLowerCase()) > -1) {
                gender.Female += each.count;
              } else if (
                ['m', 'male'].indexOf(each.gender.toLowerCase()) > -1
              ) {
                gender.Male += each.count;
              }
            });
          }
          this.setState({
            groupChartOptions: {
              gender: {
                data: [gender.Male, gender.Female],
                labels: Object.keys(gender)
              },
              relation
            }
          });
          if (_.keys(payLoad).length == 0) {
            sessionStorage.setItem(
              'groupChartOptions',
              JSON.stringify({
                gender: {
                  data: [gender.Male, gender.Female],
                  labels: Object.keys(gender)
                },
                relation
              })
            );
          }
        }
      })
      .catch((error) => {
        //alert(error);
        this.setState({
          error: {
            piechart: true
          }
        });
      });
  }
  //filter dropdown values call
  fetchFiltersValues() {
    if (sessionStorage.getItem('filterOptions')) {
      this.setState({
        filterOptions: JSON.parse(sessionStorage.getItem('filterOptions'))
      });
      return;
    }
    ClevertapReact.event('Clicked on ');
    _axios
      .get('masterData/filter', {
        ignoreLoading: true,
        headers: {
          authtoken: commonService.getAuthToken()
        }
      })
      .then((res) => {
        // let entityIdRequested = [];
        // let result = goodalipi.get('user');
        // let entityIds = { ibm: 1015134, ibm2: 1015135, ibm3: 1025369 };
        // // let entityIds = result.groupEntityList;
        // _.keys(entityIds).forEach((each) => {
        //   let obj = {};
        //   (obj['key'] = each), (obj['val'] = entityIds[each]);
        //   entityIdRequested.push(obj);
        // });
        this.setState((prev) => ({
          filterOptions: {
            ...prev.filterOptions,
            // entityRequested: entityIdRequested,
            campLocationList: res.data.campLocation,
            providerNameList: res.data.providerName,
            campTypeList: res.data.campType
          }
        }));
      })
      .catch((err) => { });
  }

  fetchPayBenFilters() {
    // if(sessionStorage.getItem('filterOptions')) {
    //   this.setState({
    //     filterOptions: JSON.parse(sessionStorage.getItem('filterOptions'))
    //   })
    //   return
    // }
    _axios
      .post(
        'masterData/paymentAndBenfFilter',
        {},
        {
          ignoreLoading: true,
          headers: {
            authtoken: commonService.getAuthToken()
          }
        }
      )
      .then((res) => {
        if (res.data.isSuccess) {
          this.setState((prev) => ({
            filterOptions: {
              ...prev.filterOptions,
              paymetnList:
                res.data.result.PaymentSource &&
                  res.data.result.PaymentSource.length
                  ? res.data.result.PaymentSource
                  : [],
              benfList:
                res.data.result.relation && res.data.result.relation.length
                  ? res.data.result.relation
                  : []
            }
          }));
        }
      })
      .catch((err) => { });
  }

  componentDidMount() {
    this.refreshTypeCount();
    this.refreshChartOption(daysToPreFetch);
    this.refreshData();
    this.fetchFiltersValues();
    this.fetchPayBenFilters();
  }

  componentDidCatch() {
    console.log('test');
  }

  render() {
    return (
      <>
        <Helmet>
          <title>Vaccination | Dashboard</title>
        </Helmet>
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
            py: 2
          }}
        >
          <Container maxWidth={false}>
            <SearchRecords
              filterOptions={this.state.filterOptions}
              filter={this.state.filter}
              setFilters={(value) => this.setState({ filter: value })}
              onRefresh={() => this.applyFilters()}
            />

            <Grid container alignItems="stretch" spacing={2} sx={{ mt: -4 }}>
              <Grid item container lg={8} xs={12}>
                <Card
                  sx={{
                    width: '100%',
                    borderRadius: 4,
                    mb: 0,
                    pt: 2,
                    boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                  }}
                >
                  <CardContent>
                    <Grid
                      container
                      direction="row"
                      justifyContent="space-around"
                      spacing={3}
                    >
                      {this.state.masterDataCountItems.map((each, idx) => (
                        <Grid
                          item
                          lg={4}
                          sm={6}
                          xl={4}
                          xs={12}
                          md={4}
                          key={idx}
                        >
                          <StatusCount selectFeature={false} status={each} />
                        </Grid>
                      ))}
                    </Grid>
                    <Grid item mt={5}>
                      <RequestChart
                        data={this.state.salesChartOptions.view}
                        refreshBarChart={(till) => {
                          this.refreshChartView(till);
                        }}
                        isHeaderRequired={true}
                      />
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item container lg={4} xs={12}>
                <Card
                  sx={{
                    width: '100%',
                    borderRadius: 4,
                    mb: 0,
                    boxShadow: '0 0 4px rgba(0,0,0,0.15)'
                  }}
                >
                  <Traffic
                    sx={{ height: '100%', width: '100%' }}
                    onRefresh={() => this.refreshTypeCount()}
                    serverError={this.state.error.piechart}
                    chartOptions={this.state.groupChartOptions}
                  />
                </Card>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </>
    );
  }
}
export default Dashboard;
